/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamMutationRequest,
  PostApiV1ExamMutationResponse,
  PostApiV1Exam400,
  PostApiV1Exam401,
  PostApiV1Exam500,
} from "../../types/examEvaluationController/PostApiV1Exam.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1Exam } from "../../clients/examEvaluationController/postApiV1Exam.ts";

export const postApiV1ExamMutationKey = () =>
  [{ url: "/api/v1/exam" }] as const;

export type PostApiV1ExamMutationKey = ReturnType<
  typeof postApiV1ExamMutationKey
>;

export function postApiV1ExamMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1ExamMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1ExamMutationKey();
  return mutationOptions<
    PostApiV1ExamMutationResponse,
    ResponseErrorConfig<PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500>,
    { data?: PostApiV1ExamMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1Exam(data, config);
    },
  });
}

/**
 * @description Cria uma nova prova com os dados fornecidos. Quando o tipo de prova é Challenge, os valores de ExamReferenceShow e ExamReferenceShowPost são forçados para Partial, independente do valor enviado. **(Requer Authorization para autenticação)**
 * @summary Criar prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam}
 */
export function usePostApiV1Exam<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamMutationResponse,
      ResponseErrorConfig<
        PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500
      >,
      { data?: PostApiV1ExamMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1ExamMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postApiV1ExamMutationKey();

  const baseOptions = postApiV1ExamMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1ExamMutationResponse,
    ResponseErrorConfig<PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500>,
    { data?: PostApiV1ExamMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1ExamMutationResponse,
    ResponseErrorConfig<PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500>,
    { data?: PostApiV1ExamMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamMutationResponse,
    ResponseErrorConfig<PostApiV1Exam400 | PostApiV1Exam401 | PostApiV1Exam500>,
    { data?: PostApiV1ExamMutationRequest },
    TContext
  >;
}
